/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ before: NonNullable<unknown>, after: NonNullable<unknown> }} Profile_Editors_Split_Change_NoteInputs */

const en_us2_profile_editors_split_change_note = /** @type {(inputs: Profile_Editors_Split_Change_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your split changes from ${i?.before} to ${i?.after} workouts. Your trainer builds a new draft and nothing changes until you accept it.`)
};

const pt_br2_profile_editors_split_change_note = /** @type {(inputs: Profile_Editors_Split_Change_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sua divisão muda de ${i?.before} para ${i?.after} treinos. O personal monta um rascunho novo e nada muda até você aceitar.`)
};

const es_419_profile_editors_split_change_note = /** @type {(inputs: Profile_Editors_Split_Change_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu división pasa de ${i?.before} a ${i?.after} entrenamientos. Tu entrenador arma un borrador nuevo y nada cambia hasta que lo aceptes.`)
};

const pt_pt2_profile_editors_split_change_note = /** @type {(inputs: Profile_Editors_Split_Change_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A tua divisão muda de ${i?.before} para ${i?.after} treinos. O treinador cria um rascunho novo e nada muda até o aceitares.`)
};

const fr_fr2_profile_editors_split_change_note = /** @type {(inputs: Profile_Editors_Split_Change_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ta répartition passe de ${i?.before} à ${i?.after} séances. Ton coach prépare un nouveau brouillon et rien ne change tant que tu ne l'acceptes pas.`)
};

const de_de2_profile_editors_split_change_note = /** @type {(inputs: Profile_Editors_Split_Change_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dein Split ändert sich von ${i?.before} auf ${i?.after} Trainings. Dein Coach erstellt einen neuen Entwurf, und nichts ändert sich, bis du ihn übernimmst.`)
};

const it_it2_profile_editors_split_change_note = /** @type {(inputs: Profile_Editors_Split_Change_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il tuo split passa da ${i?.before} a ${i?.after} allenamenti. Il coach crea una nuova bozza e non cambia nulla finché non la accetti.`)
};

/**
* | output |
* | --- |
* | "Your split changes from {before} to {after} workouts. Your trainer builds a new draft and nothing changes until you accept it." |
*
* @param {Profile_Editors_Split_Change_NoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_split_change_note = /** @type {((inputs: Profile_Editors_Split_Change_NoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Split_Change_NoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_split_change_note(inputs)
	if (locale === "es-419") return es_419_profile_editors_split_change_note(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_split_change_note(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_split_change_note(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_split_change_note(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_split_change_note(inputs)
	return en_us2_profile_editors_split_change_note(inputs)
});
export { profile_editors_split_change_note as "profile-editors.split_change_note" }